







import { Component, Vue } from 'vue-property-decorator'

/**
 * @title  展开
 * @desc 展开， 用于菜单展开时。
 */
@Component
export default class ExpandExample extends Vue {
  expand = true
}
